import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { toast } from 'sonner';

import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { removeItemFromCart } from '@/features/cart/api';

import { cartKeys } from '../keys';

import { useLocalCart } from './use-local-cart';

export const useDeleteCartItem = () => {
  const queryClient = useQueryClient();
  const { data: userData } = useCurrentUser();
  const removeToLocalCart = useLocalCart((store) => store.removeItem);

  const mutationFn = useCallback(
    async (itemId: string) => {
      if (userData) {
        return removeItemFromCart(itemId);
      }

      removeToLocalCart(itemId);
    },
    [removeToLocalCart, userData],
  );

  return useMutation({
    mutationFn: mutationFn,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: cartKeys.cart,
      });

      toast.success('Removed from cart');
    },
  });
};
